import {SINGLE_TABLE_ROW_HEIGHT} from '../../helpers/table-row-height'

export const CELL_HEIGHT = SINGLE_TABLE_ROW_HEIGHT
export const MIN_CELL_WIDTH = 75
export const GROUP_SEPARATOR_HEIGHT = Math.floor(SINGLE_TABLE_ROW_HEIGHT / 2.5)
export const TABLE_HEADER_HEIGHT = SINGLE_TABLE_ROW_HEIGHT - 3
